<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : '#000'" :class="[`${prefix}-icon`, `${prefix}-icon-swing`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M40.97 21L25.415 5.444a2 2 0 00-2.828 0L7.029 21l2.829 2.828L24 9.686l14.142 14.142L40.971 21zm4.257 8.151a.8.8 0 00-.878-.878l-7.602.786a.8.8 0 00-.483 1.362l1.874 1.873C34.54 35.184 29.565 37 24 37c-5.565 0-10.541-1.815-14.138-4.706l1.874-1.873.078-.09a.8.8 0 00-.561-1.272l-7.602-.786-.1-.004-.098.008a.8.8 0 00-.68.874l.786 7.602.017.099a.8.8 0 001.345.384l2.1-2.1C11.367 38.759 17.37 41 24 41c6.632 0 12.635-2.241 16.979-5.865l2.1 2.101a.8.8 0 001.362-.483l.786-7.602z"/></svg>
</template>
<script>

export default {
  name: 'IconSwing',
  props: {
    prefix: {
        type: String,
        default: 'arco',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
